import React, { useEffect, useState } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { Transition } from "@headlessui/react";
import { RiLogoutCircleLine } from "react-icons/ri";
import { LOKALAI_MENU } from "data/navigation";

const SidebarMenu = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [openGroup, setOpenGroup] = useState(null);

  // Convert LOKALAI_MENU into a SideLinkGroups structure
  const SideLinkGroups = LOKALAI_MENU.map((menu) => ({
    id: menu.id,
    group: menu.name,
    items: menu.children || [],
  }));

  useEffect(() => {
    for (const group of SideLinkGroups) {
      if (group.items.some((item) => location.pathname.startsWith(item.href))) {
        setOpenGroup(group.id);
        break;
      }
    }
  }, [location.pathname]);

  const logoutHandler = () => {
    toast.success("Logged out successfully");
    navigate("/");
  };

  const active = "bg-redlight text-reddark";
  const hover = "hover:text-redlight hover:bg-deepGray hover:bg-gray-700";
  const inActive =
    "rounded font-medium text-sm transitions flex gap-3 items-center p-4";

  return (
    <div className="hidden md:block bg-gray-800 rounded-md">
      {SideLinkGroups.map((section) => {
        const isOpen = openGroup === section.id;
        return (
          <div key={section.id} className="mb-4">
            <button
              onClick={() => setOpenGroup(isOpen ? null : section.id)}
              className="flex items-center justify-between w-full px-4 py-2 text-sm font-semibold text-gray-400 uppercase tracking-wider hover:text-white"
            >
              {section.group}
              <ChevronDownIcon
                className={`w-4 h-4 text-redlight transform transition-transform duration-200 ${
                  isOpen ? "rotate-180" : ""
                }`}
              />
            </button>
            <Transition
              show={isOpen}
              enter="transition-all duration-300 ease-out"
              enterFrom="opacity-0 max-h-0"
              enterTo="opacity-100 max-h-[500px]"
              leave="transition-all duration-200 ease-in"
              leaveFrom="opacity-100 max-h-[500px]"
              leaveTo="opacity-0 max-h-0"
            >
              <div className="mt-1 overflow-hidden">
                {section.items.map((item, i) => (
                  <NavLink
                    key={i}
                    to={item.href}
                    end={item.href === "/dashboard"}
                    className={({ isActive }) =>
                      `${inActive} ${isActive ? active : hover} text-white`
                    }
                  >
                    {({ isActive }) => (
                      <>
                        {item.icon && (
                          <item.icon
                            className={`text-3xl ${
                              isActive ? "text-white" : "text-redlight"
                            } transition-colors`}
                          />
                        )}
                        <div className="flex flex-col text-left">
                          <p className="text-sm leading-tight">{item.name}</p>
                          {item.subtitle && (
                            <span
                              className={`text-xs ${
                                isActive ? "text-neutral-300" : "text-gray-400"
                              } transition-colors`}
                            >
                              {item.subtitle}
                            </span>
                          )}
                        </div>
                      </>
                    )}
                  </NavLink>
                ))}
              </div>
            </Transition>
          </div>
        );
      })}
      <button
        onClick={logoutHandler}
        className={`${inActive} ${hover} w-full text-white hover:bg-gray-700`}
      >
        <RiLogoutCircleLine className="text-lg" />
        <p>Log Out</p>
      </button>
    </div>
  );
};

export default SidebarMenu;
